import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Row } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";

import { loginLog } from "./../../utils/useUser";

const GroupBuyingEvent = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const influencerId = reduxChannel?.influencer_id;

	// const [leftTime, setLeftTime] = useState("");

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const [eventStart, setEventStart] = useState(false);

	useEffect(() => {
		getTime();
	}, []);

	const getTime = async () => {
		const res = await partnersApi.getServerTime();
		if (res.code === 200) {
			const endDate = moment(res.result);
			// const endDate = moment("2023-06-27 11:12");
			const serverTime = moment("2023-07-13 12:00");
			if (endDate.diff(serverTime) > 0) {
				setEventStart(true);
			} else {
				setEventStart(false);
			}
		} else {
			setEventStart(false);
		}
	};

	return (
		<div
		// className={`quick-button-group`}
		// style={{padding: 0}}
		>
			{/*home-each */}
			{influencerId === "mediman" ? (
				<div
					className={`max-width-apply group-buying-event`}
					onClick={() => {
						if (process.env.REACT_APP_MODE === "prod") {
							window.open(
								"https://docs.google.com/spreadsheets/d/1MbELFuBi2vFlSsIMHUKzbl8sg-S8abZ7QruwxNTzzMk/edit?usp=sharing"
							);
							const inflow = document?.referrer ?? null;
							loginLog(
								{ id: reduxChannel?.user_id },
								"together-당첨자",
								inflow
							);
						}
					}}
					// style={nowDate > endDate ? { cursor: "default" } : {}}
				>
					<div
						className={`group-buying-event-banner`}
						style={
							mediaResult
								? {
										background: `url('/assets/images/channel/group-banner-m.png') bottom center / cover no-repeat`,
										// backgroundSize: "cover",
										height: "30rem",
								  }
								: {
										background: `url('/assets/images/channel/group-banner.png') top 20% right / cover no-repeat`,
										// backgroundSize: "cover",
								  }
						}
					>
						<p className={"red-title"}>늘 감사드리는 마음으로 준비했습니다.</p>
						<p className={`black-title`}>팔로워님들을 위한 깜짝 선물</p>
						<p className={`black-title`}>놓치지 말고 받아가세요!</p>
						<div className={`event-left-time`}>
							<p>
								<span>이벤트 종료일</span> | 2023년 5월 2일(화) 오후 5시
							</p>
							{/*{nowDate < endDate ? (*/}
							{/*    <p>*/}
							{/*        <span>이벤트 남은 기간</span> | {leftTime}*/}
							{/*    </p>*/}
							{/*) : (*/}
							<p>
								<span>이벤트 남은 기간</span> | 종료
							</p>
							{/*)}*/}

							{/*{leftTime?.split(":")?.map((item, idx) => (*/}
							{/*    <>*/}
							{/*        <span key={`left-date-${idx}`}>{item}</span>*/}
							{/*        {idx !== 3 ? ":" : ""}*/}
							{/*    </>*/}
							{/*))}*/}
						</div>
					</div>
					<div className={`group-buying-event-mention`}>
						{/*{nowDate < endDate ? (*/}
						{/*    <p>팔로워 이벤트 참여하기</p>*/}
						{/*) : (*/}
						{/*    <p>팔로워 이벤트 종료</p>*/}
						{/*)}*/}
						<p>당첨자 확인하기</p>
					</div>
				</div>
			) : (
				<div
					className={`${mediaResult && `max-width-apply`} group-buying-event`}
					// onClick={() => {
					//     // if (nowDate < endDate) {
					//     window.open("https://docs.google.com/spreadsheets/d/1MbELFuBi2vFlSsIMHUKzbl8sg-S8abZ7QruwxNTzzMk/edit?usp=sharing");
					//     let inflow = window?.location?.referrer;
					//     loginLog({id: reduxChannel?.user_id}, "together-당첨자", inflow)
					//     // }
					// }}
					onClick={() => {
						if (
							process.env.REACT_APP_MODE === "prod" &&
							reduxChannel?.user_id !== 7 &&
							eventStart
						) {
							window.open(
								"https://docs.google.com/forms/d/1bV9n3lYbhWkghvKlEV0ZbtQ1swii3tba0OzdwQ9An-E/edit"
							);
							const inflow = document?.referrer ?? null;
							loginLog(
								{ id: reduxChannel?.user_id },
								`together-event-${reduxChannel?.influencer_id}`,
								inflow
							);
						}
					}}
				>
					<div
						className={`group-buying-event-banner`}
						style={
							mediaResult
								? {
										// background: `url('/assets/images/channel/squid-event-m.jpg') bottom center / cover no-repeat`,
										// backgroundSize: "cover",
										// backgroundColor: "#11224e",
										backgroundColor: "#d8cdbb",
										borderRadius: 0,
										// height: "42rem",
										padding: "2.5em 2em",
								  }
								: {
										// background: `url('/assets/images/channel/squid-event.jpg') top center / cover no-repeat`,
										backgroundColor: "#d8cdbb",
										// borderRadius: "7px",
										borderRadius: 0,
										// height: "14em",
										// maxWidth: "1400px"
										// backgroundSize: "cover",
								  }
						}
					>
						{/*<p className={"red-title"} id={`home-banner-font`} style={{color: "#ff8000"}}>*/}
						<p
							className={"red-title"}
							id={`home-banner-font`}
							style={{ color: "#005da9" }}
						>
							{/*늘 감사드리는 마음으로 준비했습니다.*/}
							구독자 40만 기념 이벤트
						</p>
						<p
							className={`black-title`}
							id={`home-banner-font`}
							style={{ color: "#212529" }}
						>
							{/*갑오징어분들을 위한 깜짝 선물!*/}
							갑오징어 여러분의 소중한 의견을
						</p>
						<p
							className={`black-title`}
							id={`home-banner-font`}
							style={{ color: "#212529" }}
						>
							{/*놓치지 말고 받아가세요*/}
							들려주시고 선물 받아 가세요!
						</p>
						<div
							className={`event-left-time`}
							style={{
								paddingTop: "0.5em",
							}}
						>
							{eventStart ? (
								<p style={{ color: "#212529" }}>
									이벤트 기간 | 2023년 7월 18일(화) 오후 5시까지
								</p>
							) : (
								<p style={{ color: "#212529" }}>
									이벤트 기간 | 2023년 7월 13일(목) 오후 4시부터
								</p>
							)}
						</div>
						<Row
							justify={"space-between"}
							style={{
								paddingTop: "1em",
							}}
						>
							{eventStart && (
								<Button
									style={{
										backgroundColor: "inherit",
										border: "solid 1px #212529",
										borderRadius: "17px",
										fontSize: "1em",
										height: "auto",
									}}
								>
									이벤트 참여하기
								</Button>
							)}
							<img
								src={`/assets/images/channel/event/squid-1950.png`}
								alt={`오징어 하우스 이벤트`}
								style={{
									width: "70%",
									height: "auto",
									cursor: "pointer",
									marginLeft: "auto",
								}}
							/>
						</Row>
					</div>
				</div>
			)}
		</div>
	);
};
export default GroupBuyingEvent;
